/**
 * React Query invalidacija za tab obaveza na profilu.
 * Osvežava i AP search-v2 jer obaveze zavise od draft/implementation AP lista.
 */
import { actionPlanKeys } from '@/core/api/queries';

/** React Query root key za tab obaveza (suffix: userType, org ids, …). */
export const PROFILE_OBLIGATIONS_QUERY_ROOT = ['profile', 'obligations'];

/**
 * Invalidira i refetch-uje profile obligations query + povezani action plan search.
 * @param {import('@tanstack/react-query').QueryClient} queryClient - TanStack Query client.
 * @returns {Promise<void>}
 */
export async function invalidateAndRefetchProfileObligations(queryClient) {
  await Promise.all([
    queryClient.invalidateQueries({
      queryKey: PROFILE_OBLIGATIONS_QUERY_ROOT,
      refetchType: 'all',
    }),
    queryClient.invalidateQueries({
      queryKey: actionPlanKeys.searchV2(),
      refetchType: 'all',
    }),
  ]);
  await queryClient.refetchQueries({
    queryKey: PROFILE_OBLIGATIONS_QUERY_ROOT,
    type: 'all',
  });
}
